import { z } from 'zod';
export const groupCreateSchema = z.object({
    name: z.string().min(1, 'Grup adı zorunludur').max(100),
    slug: z
        .string()
        .max(100)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug sadece küçük harf, rakam ve tire içerebilir')
        .optional(),
    description: z.string().max(500).optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz (örn: #FF5733)')
        .optional(),
});
export const groupUpdateSchema = z.object({
    name: z.string().min(1, 'Grup adı zorunludur').max(100).optional(),
    slug: z
        .string()
        .max(100)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug sadece küçük harf, rakam ve tire içerebilir')
        .optional(),
    description: z.string().max(500).optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Geçerli bir HEX renk kodu giriniz')
        .optional(),
});
export const groupAddMemberSchema = z.object({
    userId: z.coerce.number().int().positive('Geçerli bir kullanıcı ID giriniz'),
    roleInGroup: z.enum(['owner', 'admin', 'member']).optional().default('member'),
});
export const groupUpdateMemberSchema = z.object({
    roleInGroup: z.enum(['owner', 'admin', 'member']),
});
export const groupPermissionsUpdateSchema = z.object({
    permissionIds: z.array(z.coerce.number().int().positive()).min(0),
});
//# sourceMappingURL=group.schema.js.map